<template>
  <div id="app">
    <div class="navbar">
      <button @click="activeComponent = 'HomeComponent'">Home</button>
      <button @click="activeComponent = 'AboutComponent'">About</button>
      <button @click="activeComponent = 'FilmsComponent'">Films</button>
      <button @click="activeComponent = 'MusicComponent'">Music</button>
      <button @click="activeComponent = 'ContactComponent'">Contact</button>
    </div>
    <component :is="activeComponent" />
  </div>
</template>

<script>

import HomeComponent from './components/HomeComponent.vue';
import AboutComponent from './components/AboutComponent.vue';
import ContactComponent from './components/ContactComponent.vue';
import FilmsComponent from "@/components/FilmsComponent";
import MusicComponent from "@/components/MusicComponent";

export default {
  name: 'App',
  components: {
    MusicComponent,
    FilmsComponent,
    HomeComponent,
    AboutComponent,
    ContactComponent,
  },
  data() {
    return {
      activeComponent: 'HomeComponent', // Initially, show the 'home' component
    };
  },
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background-color: black;
}
.navbar button{
  background: #2c3e50;
  color: darkgoldenrod;
  width: 20%;
  height: 3em;
  position: sticky;
  top: 0;
}
body{
  background-color: black;
}
</style>
